import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Auth.css';

function Login({ onLogin }) {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    twoFactorToken: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [requiresTwoFactor, setRequiresTwoFactor] = useState(false);
  const navigate = useNavigate();

  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post('/auth/login', formData);
      
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      
      onLogin(response.data.user);
      navigate('/dashboard');
    } catch (err) {
      if (err.response?.data?.requiresTwoFactor) {
        setRequiresTwoFactor(true);
        setError('');
      } else {
        setError(err.response?.data?.error || 'Σφάλμα κατά τη σύνδεση');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    // Redirect στο Google OAuth endpoint
    window.location.href = '/api/auth/google';
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-icon">📋</div>
          <h1>Διαχείριση<br/>Υποχρεώσεων</h1>
          <h2>Σύνδεση</h2>
        </div>

        {error && <div className="error-message">{error}</div>}

        {/* Google Sign In Button */}
        <button 
          type="button" 
          onClick={handleGoogleLogin}
          className="google-btn"
          disabled={!GOOGLE_CLIENT_ID}
        >
          <img 
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
            alt="Google"
            style={{ width: '20px', height: '20px', marginRight: '10px' }}
          />
          Σύνδεση με Google
        </button>

        {!GOOGLE_CLIENT_ID && (
          <div className="info-message" style={{ marginTop: '10px', fontSize: '13px' }}>
            💡 Ο διαχειριστής χρειάζεται να ρυθμίσει το Google OAuth
          </div>
        )}

        <div className="divider">
          <span>ή</span>
        </div>

        {/* Traditional Login Form (για admins) */}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Κωδικός</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          {requiresTwoFactor && (
            <div className="form-group">
              <label>2FA Token</label>
              <input
                type="text"
                name="twoFactorToken"
                value={formData.twoFactorToken}
                onChange={handleChange}
                placeholder="123456"
                maxLength="6"
                required
                autoFocus
                style={{ 
                  fontSize: '20px', 
                  textAlign: 'center', 
                  letterSpacing: '4px' 
                }}
              />
              <small style={{ color: '#666', fontSize: '12px' }}>
                Εισάγαγε τον κωδικό από το authenticator app σου
              </small>
            </div>
          )}

          <button 
            type="submit" 
            className="btn-primary"
            disabled={loading}
          >
            {loading ? 'Σύνδεση...' : 'Σύνδεση'}
          </button>
        </form>

        <div className="auth-footer">
          <p className="info-text">
            💡 Μόνο εξουσιοδοτημένοι χρήστες μπορούν να συνδεθούν.<br/>
            Επικοινωνήστε με τον διαχειριστή για πρόσβαση.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
